module.exports = __webpack_public_path__ + "static/semi-trailer-hardcover-3726bc7ded2f46293ca0ecfed24637c0.png";